import React, { Component } from 'react'
import { Button, Form, Select, message, Spin, DatePicker, Card, Collapse } from 'antd'
import {connect} from 'dva'
import { all, create, get } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment/locale/es';
import config from '../../utils/config'
import { getTotal } from '../../utils'
import Currency from 'react-currency-formatter';
import IntegrationFactor from './integrationFactor';
import IMSS from './imss'
import ISR from './isr'
import Subsidy from './subsidy'
const _ = require('underscore')
var Icon = require('react-fontawesome');
moment.locale('es');

const Panel = Collapse.Panel
const FormItem = Form.Item;
const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;

class Total extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
        }

        if (localStorage.getItem('currentHotel')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {

    }


    /**
    * Render del componente
    */
    render () {
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        Configuración
                    </h1>
                </section>

                <section className="content">
                    <Collapse accordion defaultActiveKey={['0']} className="marginBottom20">
                        <Panel header="Factor de integración" key="1">
                            <IntegrationFactor />
                        </Panel>

                        <Panel header="Determinación cuotas IMSS" key="2">
                            <IMSS />
                        </Panel>

                        <Panel header="Tabla ISR Quincenal" key="3">
                            <ISR />
                        </Panel>

                        <Panel header="Tabla Subsidio Quincenal" key="4">
                            <Subsidy />
                        </Panel>
                    </Collapse>
                </section>
            </div>
        )
    }
}

Total.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({adon, app}) => ({adon, app}))(Form.create()(Total))


// WEBPACK FOOTER //
// ./src/components/config/config.js